import QnA from 'components/organisms/QnA';

export default function QnASection() {
  return (
    <QnA />
  );
}
